import Sort from './Sort'
import Pagination from './Pagination'
import Search from './Search'
import Filter from './Filter'
import Fields from './Fields'

export default class Psfs {
  static get PARAM_CRITERIA() {
    return 'criteria'
  }

  static create(url) {
    return new this(url)
  }

  _path = null

  _sort = null

  _pagination = null

  _search = null

  _filters = null

  _fields = null

  constructor(path = '') {
    this.init(path)
  }

  init(path) {
    this._path = path
    this._sort = new Sort(path)
    this._pagination = new Pagination(path)
    this._search = new Search(path)
    this._filters = new Filter(path)
    this._fields = new Fields(path)
  }

  addSort(field, order) {
    this._sort.setSort(field, order)

    return this
  }

  addPagination(offset, limit) {
    this._pagination.setPagination(offset, limit)

    return this
  }

  addSearch(search, fields) {
    this._search.setSearch(search, fields)

    return this
  }

  addFilter(field, value, type) {
    this._filters.setFilter(field, value, type)

    return this
  }

  addFields(fields) {
    this._fields.setFields(fields)

    return this
  }

  clearFilter(field) {
    this._filters.clearFilter(field)

    return this
  }

  clearAllFilters() {
    this._filters.clearAll()

    return this
  }

  createSort(field, type) {
    this.init(this._path)
    this._sort.setSort(field, type)

    return this
  }

  createPagination(page, limit) {
    this.init(this._path)
    this._pagination.setPagination(page, limit)

    return this
  }

  createSearch(search, fields) {
    this.init(this._path)
    this._search.setSearch(search, fields)

    return this
  }

  createFilter(field, value, type) {
    this.init(this._path)
    this._filters.setFilter(field, value, type)

    return this
  }

  createFields(fields) {
    this.init(this._path)
    this._fields.setFields(fields)

    return this
  }

  clearCriteria() {
    this._path = this.pathWithoutCriteria
    this.init(this._path)

    return this
  }

  get criteriaPath() {
    const psfsString =
      this._pagination.getCriteria() +
      this._sort.getCriteria() +
      this._filters.getCriteria() +
      this._search.getCriteria() +
      this._fields.getCriteria()

    return psfsString ? `/${Psfs.PARAM_CRITERIA}/${psfsString}` : ''
  }

  queryParams(displayOptions) {
    const paginationString = this._pagination.getApiCriteria(displayOptions)
    const sortString = this._sort.getApiCriteria()
    const filterString = this._filters.getApiCriteria()
    const searchString = this._search.getApiCriteria()
    const fieldsString = this._fields.getApiCriteria()
    const queryArray = []

    if (paginationString) queryArray.push(paginationString)

    if (sortString) queryArray.push(sortString)

    if (filterString) queryArray.push(filterString)

    if (searchString) queryArray.push(searchString)

    if (fieldsString) queryArray.push(fieldsString)

    return queryArray.join('&')
  }

  get path() {
    let prevPath = ''
    const oldCrPos = this._path.search(
      new RegExp(`/${Psfs.PARAM_CRITERIA}/`, 'i'),
    )

    if (oldCrPos < 0)
      prevPath =
        this._path.substr(-1) === '/'
          ? this._path.substr(0, this._path.length - 1)
          : this._path
    else prevPath = this._path.substr(0, oldCrPos)

    return prevPath + this.criteriaPath
  }

  get pathWithoutCriteria() {
    let prevPath = ''
    const oldCrPos = this._path.search(
      new RegExp(`/${Psfs.PARAM_CRITERIA}/`, 'i'),
    )

    if (oldCrPos < 0)
      prevPath =
        this._path.substr(-1) === '/'
          ? this._path.substr(0, this._path.length - 1)
          : this._path
    else prevPath = this._path.substr(0, oldCrPos)

    return prevPath
  }

  get paginationObj() {
    return this._pagination
  }

  get sortObj() {
    return this._sort
  }

  get filtersObj() {
    return this._filters
  }

  get searchObj() {
    return this._search
  }

  get fieldsObj() {
    return this._fields
  }
}
